export const API_BASE_URL =
    process.env.REACT_APP_STAGE === 'dev' ?
        `http://${location.hostname}:8000/api` :
        `https://${location.hostname}/api`;
